export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6Lezq-8tAAAAAAL04Nbqy7YkzZscBnMcLOd5GM3H';

declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}

/**
 * Ejecuta Google reCAPTCHA v3 Fraud Defence y obtiene el token de verificación
 * @param action Nombre de la acción (ej: 'login', 'forgot_password', 'contact_form')
 * @returns Token de reCAPTCHA o null si no está disponible
 */
export async function getRecaptchaToken(action: string): Promise<string | null> {
  if (typeof window === 'undefined') return null;

  try {
    // Si grecaptcha aún no está en window, esperar hasta 2 segundos
    if (!window.grecaptcha) {
      const isLoaded = await new Promise<boolean>((resolve) => {
        let attempts = 0;
        const interval = setInterval(() => {
          attempts++;
          if (window.grecaptcha) {
            clearInterval(interval);
            resolve(true);
          } else if (attempts > 20) {
            clearInterval(interval);
            resolve(false);
          }
        }, 100);
      });

      if (!isLoaded || !window.grecaptcha) {
        console.warn('reCAPTCHA v3 no está disponible o fue bloqueado por una extensión.');
        return null;
      }
    }

    return await new Promise<string | null>((resolve) => {
      window.grecaptcha!.ready(async () => {
        try {
          const token = await window.grecaptcha!.execute(RECAPTCHA_SITE_KEY, { action });
          resolve(token);
        } catch (err) {
          console.warn(`Error al ejecutar reCAPTCHA para la acción "${action}":`, err);
          resolve(null);
        }
      });
    });
  } catch (error) {
    console.warn('Fallo inesperado al invocar reCAPTCHA:', error);
    return null;
  }
}
